import dataApi from '../../../api/index.js'
import router from '../../../router'

const namespaced = true

const state = {
  simpleTree: 'simpletree'
}

const mutations = {
  setOrganizationSimpleTree (state, credentials) {
    if (dataApi.getJwtToken()) {
      dataApi.endpoints.organization.getSimpleTree().then((response) => {
        if (response.status === 200) {
          state.simpleTree = response.body
        }
      }, (response) => {
        router.push({
          name: 'generic.error.ErrorPage',
          params: {
            error_response: {
              error_message: 'could_not_load'
            }
          }
        })
      })
    }
  }
}

const getters = {
  getOrganizationSimpleTree: (state) => {
    return state.simpleTree
  }
}

export default {
  namespaced,
  state,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/vuex/modules/general/organizationSimpleTree.js